import { CustomApiHandlerDiscreteParameter } from "@BrasselerSurgical/Store/CustomHandlerCreator";
import { CustomSuggestionSectionModel } from "@BrasselerSurgical/Types/SuggestionModel";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";


interface UpdateSelectedCartLinesParameter {
    searchResult: CustomSuggestionSectionModel;
}

type HandlerType = CustomApiHandlerDiscreteParameter<UpdateSelectedCartLinesParameter, void, void, {}>;

export const SetSearchResult: HandlerType = props => {
    props.dispatch({
        type: "Custom/Search/SetSearchResult",
        searchResult: props.parameter.searchResult,
    });
};

export const chain = [SetSearchResult];

const updateSearchResults = createHandlerChainRunner(chain, "UpdateSearchResults");

export default updateSearchResults;
